document.addEventListener("DOMContentLoaded", function() {
  const lazyVideos = document.querySelectorAll('.vsl-lazy');

  if (!lazyVideos.length) return;

  lazyVideos.forEach(function (video) {
    const vimeoId = video.getAttribute('data-vimeo-id');
    if (!vimeoId) return;

    // Optional: Fallback-Text, falls kein Thumbnail gesetzt ist
    if (!video.style.backgroundImage) {
      video.style.backgroundColor = '#000';
    }

    video.addEventListener('click', function () {
      const iframe = document.createElement('iframe');
      iframe.setAttribute(
        'src',
        'https://player.vimeo.com/video/' + vimeoId + '?autoplay=1'
      );
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute(
        'allow',
        'autoplay; fullscreen; picture-in-picture'
      );
      iframe.setAttribute('allowfullscreen', '');
      iframe.style.width = '100%';
      iframe.style.height = '100%';

      this.innerHTML = '';
      this.appendChild(iframe);
      this.classList.add('vsl-loaded');
    });
  });
});
